import script from "./ManageUserAccessTokensPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManageUserAccessTokensPage.vue?vue&type=script&lang=ts&setup=true"

import "./ManageUserAccessTokensPage.vue?vue&type=style&index=0&id=86d1bef2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d1bef2"]])

export default __exports__